let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j6zhg")).then(() => parcelRequire('6gxDB'));